import { useState } from 'react';
import { BusinessCardCustomization, BusinessCardLocationData } from '../types/cart';
import { BusinessCardCustomizerProps } from '../types/calendar';
import { BusinessCardForm } from './business-card/BusinessCardForm';
import { BusinessCardPreview } from './business-card/BusinessCardPreview';

const PHONE_FIELDS = ['phone', 'cell_phone', 'fax', 'customer_service_phone', 'toll_free'];

function formatPhoneNumber(value: string): string {
  const digits = value.replace(/\D/g, '').slice(0, 10);
  if (digits.length === 0) return '';
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
}

export function BusinessCardCustomizer({
  onCustomizationChange,
  initialCustomization,
  productImages,
  previewImage,
  withBorder = true,
  style,
  fields = [],
  options,
}: BusinessCardCustomizerProps) {
  const cardClass = withBorder ? 'bg-white rounded-xl shadow-lg border border-gray-200 p-6' : '';
  const [data, setLocation] = useState<BusinessCardLocationData>(initialCustomization || {});

  const handleFieldChange = (field: string, value: string) => {
    const processedValue = PHONE_FIELDS.includes(field) ? formatPhoneNumber(value) : value;
    const updated = { ...data, [field]: processedValue };
    setLocation(updated);
    onCustomizationChange(updated as BusinessCardCustomization);
  };

  const fontColor = options?.color || undefined;

  return (
    <div className="space-y-8">
      {options?.text_message && (
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 text-sm text-blue-800">
          {options.text_message}
        </div>
      )}

      <div className={cardClass}>
        <h3 className="text-xl font-semibold text-gray-900 mb-4">Print Preview</h3>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <BusinessCardForm data={data} onFieldChange={handleFieldChange} fields={fields} />
          <BusinessCardPreview
            productImages={productImages}
            previewImage={previewImage}
            data={data}
            style={style}
            fields={fields}
            fontColor={fontColor}
          />
        </div>
      </div>
    </div>
  );
}
